/**
 * Public frontend configuration only.
 * Do not use process.env here.
 * Do not place secrets here.
 * Backend secrets must remain only in backend .env.
 */

const statsPlaceholders = [
  { key: "subscribers", value: "125,000+" },
  { key: "towers", value: "1,250+" },
  { key: "capacity", value: "3.2 Tbps" },
  { key: "availability", value: "98.7%" },
  { key: "channels", value: "15,000+" },
];

const networkStatusPlaceholders = [
  { key: "internet", value: "100%" },
  { key: "iptv", value: "98.9%" },
  { key: "radius", value: "100%" },
  { key: "core", value: "99.8%" },
  { key: "international", value: "100%" },
];

const socialLinks = {
  facebook: "#",
  instagram: "#",
  x: "#",
  linkedin: "#",
  youtube: "#",
};

const coverageStatuses = {
  served_active: {
    color: "#2ef2a5",
    ar: "منطقة مخدمة حاليًا",
    en: "Served / Active Service",
  },
  temporarily_closed: {
    color: "#ffb84a",
    ar: "مغلقة مؤقتًا بسبب الضغط",
    en: "Temporarily Closed Due To High Load",
  },
  under_deployment: {
    color: "#40a9ff",
    ar: "قيد التخديم / قريبًا",
    en: "Under Deployment / Coming Soon",
  },
  not_served: {
    color: "#ff5c7a",
    ar: "غير مخدمة حاليًا",
    en: "Not Served",
  },
  conditional_service: {
    color: "#b37dff",
    ar: "مخدمة بشروط معينة",
    en: "Conditional Service",
  },
};

const smartNocData = {
  cards: [
    "Network Online",
    "IPTV Servers Online",
    "Radius Online",
    "MikroTik Online",
    "Firewalls Online",
    "Cloud Servers Online",
  ],
  charts: {
    bandwidthUsage: [
      { name: "00", value: 61 },
      { name: "04", value: 66 },
      { name: "08", value: 72 },
      { name: "12", value: 78 },
      { name: "16", value: 84 },
      { name: "20", value: 74 },
      { name: "24", value: 69 },
    ],
    networkTraffic: [
      { name: "INT", upload: 48, download: 79 },
      { name: "IPTV", upload: 37, download: 72 },
      { name: "Cloud", upload: 53, download: 67 },
      { name: "Core", upload: 46, download: 81 },
    ],
    alerts: [
      { name: "Critical", value: 2 },
      { name: "Warning", value: 6 },
      { name: "Info", value: 13 },
    ],
    topLocations: [
      { name: "Damascus", value: 32 },
      { name: "Aleppo", value: 24 },
      { name: "Homs", value: 17 },
      { name: "Latakia", value: 14 },
    ],
  },
};

export const siteConfig = {
  // canonical public fields
  companyName: "TWIN TC LLC",
  siteTitle: "TWIN TC LLC | Premium ISP & Technology",
  siteDescription:
    "Official TWIN TC website for ISP, IPTV, Smart NOC, Cloud, and AI technology services.",
  whatsappMain: "+963 966 655 540",
  phoneMain: "+963 966 655 540",
  supportPhone: "+963 966 655 540",
  email: "info@twin-tc.net",
  location: "Damascus, Syria",
  socialLinks,
  clientPortalUrl: "/client-portal",
  coverageMapUrl: "/coverage-map",
  adminCoverageUrl: "/admin/coverage",
  twinTvDownloadUrl: "https://twin-tc.net/downloads/twin-tv.apk",
  defaultLanguage: "ar",
  statsPlaceholders,
  networkStatusPlaceholders,

  // retained keys for current component compatibility
  brand: {
    name: "TWIN TC LLC",
    shortName: "TWIN TC",
    twinTvName: "TWIN TV",
    copyright: "© 2026 TWIN TC LLC. All Rights Reserved.",
  },
  cta: {
    clientPortal: "/client-portal",
    coverageAnchor: "#coverage",
    servicesAnchor: "#services",
    openCoverageMap: "/coverage-map",
    adminCoverage: "/admin/coverage",
    twinTvAndroid: "https://twin-tc.net/downloads/twin-tv.apk",
    twinTvIOS: "coming-soon",
  },
  contact: {
    whatsapp: "+963 966 655 540",
    phone: "+963 966 655 540",
    supportPhone: "+963 966 655 540",
    email: "info@twin-tc.net",
    location: "Damascus, Syria",
  },
  social: socialLinks,
  stats: statsPlaceholders,
  networkStatus: networkStatusPlaceholders,
  coverageStatuses,
  smartNoc: smartNocData,
};
